
import Vue from "vue";
import { NewToiletsApiFunc, setAccessToken } from "@/api";
import { Toilet, ToiletType, ToiletStatus } from "@/models";

import TheTemplate from "../TheNoSidebarTemplate.vue";
import BaseCloseButton from "@/components/BaseCloseButton.vue";
import BaseSubmitButton from "@/components/BaseSubmitButton.vue";
import BaseCancelButton from "@/components/BaseCancelButton.vue";
import BaseChuiGaki from "@/components/BaseChuiGaki.vue";

export type DataType = {
  toilet?: Toilet;
};

export default Vue.extend({
  name: "ToiletDeleteScreen",

  components: {
    BaseChuiGaki,
    TheTemplate,
    BaseCloseButton,
    BaseSubmitButton,
    BaseCancelButton,
  },

  data(): DataType {
    return {
      toilet: new Toilet(),
    };
  },

  computed: {
    floor(): string {
      return this.toilet?.floor || "";
    },

    toiletType(): string {
      switch (this.toilet?.toiletType) {
        case ToiletType.FOR_MAN:
          return "男性トイレ";
        case ToiletType.FOR_WOMAN:
          return "女性トイレ";
        case ToiletType.UNISEX:
          return "共用トイレ";
        case ToiletType.MULTI_PURPOSE:
          return "多目的トイレ";
        default:
          return "";
      }
    },

    name(): string {
      return this.toilet?.name || "";
    },

    gatewayMac(): string {
      return this.toilet?.gatewayMac || "";
    },

    numOfBoxes(): string {
      return String(this.toilet?.boxesCount || 0);
    },

    statusText(): string {
      switch (this.toilet?.status) {
        case ToiletStatus.RUNNING:
          return "稼動";
        case ToiletStatus.IN_MAINTENANCE:
          return "メンテ中";
        case ToiletStatus.IN_PREPARING:
          return "準備中";
        default:
          return "不明";
      }
    },

    statusClassText(): string {
      switch (this.toilet?.status) {
        case ToiletStatus.RUNNING:
          return "";
        case ToiletStatus.IN_MAINTENANCE:
          return "red";
        case ToiletStatus.IN_PREPARING:
          return "red";
        default:
          return "";
      }
    },
  },

  mounted() {
    this.getToilet();
  },

  methods: {
    async getToilet(): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      const toiletId = this.$router.currentRoute.params.toiletId;
      setAccessToken(this.$auth.accessToken);
      const { data, err } = await NewToiletsApiFunc().getToilet(
        companyId,
        toiletId
      );

      if (err != null) {
        this.$handleApiError(err, this.getToilet);
        return;
      }

      this.toilet = data;
    },

    async deleteToilet(): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      this.$setChecked(true);

      const toiletId = this.$router.currentRoute.params.toiletId;
      setAccessToken(this.$auth.accessToken);
      const { err } = await NewToiletsApiFunc().deleteToilet(
        companyId,
        toiletId
      );

      if (err != null) {
        this.$handleApiError(err, this.deleteToilet);
        this.$setLoading(false);
        return;
      }
      this.$setLoading(false);
      this.$setChecked(true);
      this.$afterSuccessRequest(() => {
        this.$router.push({
          name: "company-toilets",
          params: {
            updated: "true",
          },
        });
      }, 2);
    },

    afterLeave(): void {
      this.$setChecked(false);
    },
  },
});
